import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { deleteAccount } from '../services/api';
import { secureStorage } from '../utils/security';

// Self-service account deletion, shown in the customer and supplier profile.
// The backend anonymizes the account (see backend/accounts/deletion.py).
export default function DeleteAccountCard({ isSupplier = false }) {
  const { logout } = useAuth();
  const [pwd,  setPwd]  = useState('');
  const [busy, setBusy] = useState(false);
  const [err,  setErr]  = useState('');

  const submit = async () => {
    setErr('');
    if (!pwd) return setErr('Onaylamak için şifrenizi girin.');
    if (!window.confirm('Hesabınız kalıcı olarak silinecek. Bu işlem geri alınamaz. Devam edilsin mi?')) return;
    setBusy(true);
    try {
      await deleteAccount(pwd);
      // The session is already revoked server-side — just clear it locally.
      secureStorage.clearToken();
      sessionStorage.removeItem('_r');
      logout();
      window.alert('Hesabınız ve kişisel verileriniz silindi.');
      window.location.replace('/');
    } catch (e) {
      setErr(e.response?.data?.message || 'Hesap silinemedi.');
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-red-100 shadow-sm p-7">
      <h3 className="text-base font-bold text-red-700 mb-1">Hesabımı Sil</h3>
      <p className="text-xs text-gray-500 mb-4 leading-relaxed">
        Hesabınız kalıcı olarak kapatılır; adınız, e-postanız, telefonunuz
        {isSupplier ? ', stok ilanlarınız ve banka bilgileriniz' : ''} silinir. Yasal olarak saklanması
        gereken işlem kayıtları anonim olarak tutulur. Bu işlem geri alınamaz.{' '}
        <a href="/yasal/hesap-silme" className="text-blue-700 underline">Ayrıntılar</a>
      </p>
      {err && <p className="text-xs text-red-600 mb-3">{err}</p>}
      <input type="password" autoComplete="current-password" placeholder="Şifreniz" maxLength={128}
        className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm mb-3 focus:outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100 transition"
        value={pwd} onChange={e => setPwd(e.target.value)} />
      <button onClick={submit} disabled={busy}
        className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-300 text-white font-semibold py-2.5 rounded-xl text-sm transition">
        {busy ? 'Siliniyor…' : 'Hesabımı Kalıcı Olarak Sil'}
      </button>
    </div>
  );
}
